import { useEffect, useState } from "react";
import { Alert, Card, Empty, Tag, Typography } from "antd";
import { GET_PROJECT_VALUE_ADDS_URL } from "../../../config/constants";
import { apiFetch } from "../../../utils/apiClient";
import DataState from "../../../components/DataState/DataState";





const getAuthHeader = () => {
  const token =
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("authToken") ||
    sessionStorage.getItem("accessToken");

  if (!token) return {};

  const tokenType = sessionStorage.getItem("tokenType") || "Bearer";
  const normalizedToken = String(token).replace(/^"|"$/g, "").replace(/^Bearer\s+/i, "").trim();
  if (!normalizedToken) return {};

  return { Authorization: `${tokenType} ${normalizedToken}` };
};

export default function ValueAddsReadOnlyView({ projectId }) {
  const [reloadCount, setReloadCount] = useState(0);
  // Each result is tagged with the request key it answered, so a new request
  // (project change or retry) is "loading" on its first render and never shows old items.
  const [result, setResult] = useState({ key: null, items: [], error: null });

  const requestKey = `${projectId}|${reloadCount}`;
  const hasCurrentResult = result.key === requestKey;
  const items = hasCurrentResult ? result.items : [];
  const status = !projectId ? "ready" : !hasCurrentResult ? "loading" : result.error ? "error" : "ready";

useEffect(() => {
  if (!projectId) return;

  let ignore = false;
  const key = `${projectId}|${reloadCount}`;

  const fetchValueAdds = async () => {
    try {
      const response = await apiFetch(GET_PROJECT_VALUE_ADDS_URL(projectId), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          ...getAuthHeader(),
        },
      }, "Failed to load value adds");

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);

        throw new Error(
          errorData?.message || "Failed to load value adds"
        );
      }

      const data = await response.json();

      const source = Array.isArray(data?.valueAddList)
        ? data.valueAddList
        : [];

      const mapped= source
        .filter((item) => !item.deleted)
        .map((item) => ({
          id: String(item.valueAddId || item.id || Math.random()),
          title: String(item.title || ""),
          description: String(item.description || ""),
        }));

      if (!ignore) setResult({ key, items: mapped, error: null });
    } catch (error) {
      console.error(error);

      if (!ignore) {
        setResult({
          key,
          items: [],
          error: error instanceof Error ? error.message : "Failed to load value adds",
        });
      }
    }
  };

  fetchValueAdds();

  return () => {
    ignore = true;
  };
}, [projectId, reloadCount]);

  return (
    <DataState
      status={status}
      errorTitle="Couldn't load value adds"
      error={result.error}
      onRetry={() => setReloadCount((count) => count + 1)}
      skeletonRows={4}
    >
    <Card
      style={{ borderRadius: 14, border: "1px solid #f0f0f0" }}
      styles={{ body: { padding: 16 } }}
      title={
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontWeight: 600, fontSize: 14 }}>Value Adds</span>
          <Tag color="green">{items.length}</Tag>
        </div>
      }
    >
      <div style={{ maxHeight: 500, overflowY: "auto" }}>
        {items.length === 0 && (
          <Empty description="No value adds yet" style={{ marginTop: 32 }} />
        )}

        {items.length > 0 && (
          <div style={{ fontSize: 13 }}>
            {items.map((item) => (
              <div key={item.id} style={{ paddingBottom: 12, marginBottom: 12, borderBottom: "1px solid #f0f0f0" }}>
                <Typography.Text strong style={{ display: "block", marginBottom: 4 }}>
                  {item.title}
                </Typography.Text>
                <Typography.Text style={{ color: "#595959" }}>{item.description}</Typography.Text>
              </div>
            ))}
          </div>
        )}
      </div>
    </Card>
    </DataState>
  );
}
